import { useHotel } from '@/context/hotel-context';
import { ReportSubscriptionsList } from '@/features/report-subscriptions';

function Scheduler() {
  const { hotel } = useHotel();

  // Get the brand code from the current hotel context
  const brandCode = hotel?.brand_code;

  return <ReportSubscriptionsList brandCode={brandCode} />;
}

export default Scheduler;
